// extracted by mini-css-extract-plugin
export default {"card":"a6-z"};